import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { I18nService } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-technical-support',
  templateUrl: './bmcore-tech-support-page.component.html',
  styleUrls: ['./bmcore-tech-support-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTechSupportPageComponent implements OnInit {
  isEng: boolean

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.isEng = this.i18nService.isEng()
  }
}
